import { DateTime } from 'luxon';
import { ICountryMessage } from '../../admin/countries/countries.models';

const WELCOME_PAGE_TYPE = 'WELCOME_PAGE';

const isWithinDisplayWindow = (
  message: ICountryMessage,
  now: DateTime
): boolean => {
  if (message.displayTime === 'STATIC') {
    return true;
  }
  if (message.displayTime === 'DYNAMIC') {
    return (
      DateTime.fromISO(message.dateFrom).startOf('day') <= now &&
      now <= DateTime.fromISO(message.dateTo).endOf('day')
    );
  }
  return false;
};

export const filterActiveWelcomeMessages = (
  messages: ICountryMessage[],
  now: DateTime
): ICountryMessage[] =>
  messages.filter(
    (message) =>
      message.active &&
      message.type === WELCOME_PAGE_TYPE &&
      isWithinDisplayWindow(message, now)
  );
